// extracted by mini-css-extract-plugin
export var editButton = "_nb-0";